'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  margin: 5px;\n  position: relative;\n  text-align: left;\n  ', ';\n  label {\n    font-weight: 400 !important;\n  }\n  [type="checkbox"]:checked,\n  [type="checkbox"]:not(:checked) {\n      position: absolute;\n      left: -9999px;\n  }\n  [type="checkbox"]:checked + label,\n  [type="checkbox"]:not(:checked) + label\n  {\n    position: relative;\n    padding-left: 28px;\n    cursor: pointer;\n    line-height: 20px;\n    display: inline-block;\n    color: ', ';\n  }\n  [type="checkbox"]:checked + label:before,\n  [type="checkbox"]:not(:checked) + label:before {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 20px;\n    height: 20px;\n    border:  ', ';\n    ', '\n    border-radius: ', ';\n  }\n  [type="checkbox"]:checked + label:after,\n  [type="checkbox"]:not(:checked) + label:after {\n    content: \'\';\n    width: 12px;\n    height: 12px;\n    ', '\n    position: absolute;\n    top: 4px;\n    left: 4px;\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n  }\n  [type="checkbox"]:not(:checked) + label:after {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  [type="checkbox"]:checked + label:after {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n  [type="checkbox"]:checked + label:before {\n    content: ', ';\n    font-family: \'icomoon\' !important;\n    border:  ', ';\n    text-align: center;\n    color: white;\n    ', '\n    border-radius: ', ';\n  }\n'], ['\n  margin: 5px;\n  position: relative;\n  text-align: left;\n  ', ';\n  label {\n    font-weight: 400 !important;\n  }\n  [type="checkbox"]:checked,\n  [type="checkbox"]:not(:checked) {\n      position: absolute;\n      left: -9999px;\n  }\n  [type="checkbox"]:checked + label,\n  [type="checkbox"]:not(:checked) + label\n  {\n    position: relative;\n    padding-left: 28px;\n    cursor: pointer;\n    line-height: 20px;\n    display: inline-block;\n    color: ', ';\n  }\n  [type="checkbox"]:checked + label:before,\n  [type="checkbox"]:not(:checked) + label:before {\n    content: \'\';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 20px;\n    height: 20px;\n    border:  ', ';\n    ', '\n    border-radius: ', ';\n  }\n  [type="checkbox"]:checked + label:after,\n  [type="checkbox"]:not(:checked) + label:after {\n    content: \'\';\n    width: 12px;\n    height: 12px;\n    ', '\n    position: absolute;\n    top: 4px;\n    left: 4px;\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n  }\n  [type="checkbox"]:not(:checked) + label:after {\n    opacity: 0;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n  [type="checkbox"]:checked + label:after {\n    opacity: 1;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n  [type="checkbox"]:checked + label:before {\n    content: ', ';\n    font-family: \'icomoon\' !important;\n    border:  ', ';\n    text-align: center;\n    color: white;\n    ', '\n    border-radius: ', ';\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: 0.5em 0;\n'], ['\n  margin: 0.5em 0;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CheckBoxContainer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.border ? 'padding: 15px 7px; border: 1px solid ' + _color2.default.grey_accent_1 + '; border-radius: 5px; box-shadow: 0 2px 4px 0 rgba(0,0,0,0.1);' : '';
}, _color2.default.grey_main, function (props) {
  return props.colorStyle === 'purple' ? '1px solid ' + _color2.default.blue_accent : 'none';
}, function (props) {
  return props.colorStyle === 'purple' ? '' : 'background: linear-gradient(180deg, ' + _color2.default.grey_accent_2 + ' 0%, ' + _color2.default.grey_accent_1 + ' 100%);';
}, function (props) {
  return props.borderRadius ? props.borderRadius : '5px';
}, function (props) {
  return props.colorStyle === 'purple' ? 'background: ' + _color2.default.blue_accent + '; border-radius: 2px;' : '';
}, function (props) {
  return props.colorStyle === 'purple' ? '' : '"\\e922" !important';
}, function (props) {
  return props.colorStyle === 'purple' ? '1px solid ' + _color2.default.blue_accent : 'none';
}, function (props) {
  return props.colorStyle === 'purple' ? '' : 'background: linear-gradient(180deg, ' + _color2.default.orange_accent + ' 0%, ' + _color2.default.orange_main + ' 100%);';
}, function (props) {
  return props.borderRadius ? props.borderRadius : '5px';
});

var Item = _styledComponents2.default.div(_templateObject2);

var MozartCheckBox = function (_Component) {
  _inherits(MozartCheckBox, _Component);

  function MozartCheckBox(props) {
    _classCallCheck(this, MozartCheckBox);

    var _this = _possibleConstructorReturn(this, (MozartCheckBox.__proto__ || Object.getPrototypeOf(MozartCheckBox)).call(this, props));

    _this.state = {
      groupname: props.groupname ? props.groupname : Math.random(),
      selected: [],
      border: _this.props.border
    };

    _this.state.selected = _this.props.content ? _this.props.content.filter(function (item) {
      return item.checked === true;
    }) : [];
    return _this;
  }

  _createClass(MozartCheckBox, [{
    key: 'getCheckBoxItem',
    value: function getCheckBoxItem(item) {
      var _this2 = this;

      var _onChange = this.props.onChange;
      var name = item.name,
          id = item.id,
          value = item.value,
          checked = item.checked,
          disabled = item.disabled;

      var key = id ? id : (name + value + checked).split(' ').join('').toLowerCase();
      return _react2.default.createElement(
        Item,
        { key: key },
        _react2.default.createElement('input', {
          ref: 'checkbox' + key,
          type: 'checkbox',
          id: 'checkbox' + key,
          disabled: disabled,
          onChange: function onChange(event) {
            var checked = event.target.checked;
            var selected = _this2.state.selected.filter(function (item_) {
              return item_.value !== item.value;
            });
            if (checked) {
              selected.push(item);
            }
            _this2.setState({ selected: selected }, function () {
              _onChange(selected, value, checked);
            });
            if (item.onClick) {
              item.onClick(item, event.target.checked);
            }
          },
          defaultChecked: checked,
          name: this.state.groupname
        }),
        _react2.default.createElement(
          'label',
          { htmlFor: 'checkbox' + key, title: name },
          name
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          borderRadius = _props.borderRadius,
          content = _props.content,
          border = _props.border,
          colorStyle = _props.colorStyle,
          children = _props.children,
          style = _props.style,
          themeId = _props.themeId;


      if (content) {
        return _react2.default.createElement(
          CheckBoxContainer,
          { 'data-qa': this.props.testId, borderRadius: borderRadius, colorStyle: colorStyle, border: border, style: style, 'data-theme': themeId },
          content.map(this.getCheckBoxItem.bind(this))
        );
      }
      if (!content) {
        return _react2.default.createElement(
          CheckBoxContainer,
          { 'data-qa': this.props.testId, borderRadius: borderRadius, colorStyle: colorStyle, border: border, style: style, 'data-theme': themeId },
          children
        );
      }
    }
  }]);

  return MozartCheckBox;
}(_react.Component);

MozartCheckBox.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** groupname attribute */
  groupname: _propTypes2.default.string,
  /** override style */
  style: _propTypes2.default.object,
  /** children node */
  children: _propTypes2.default.node,
  /** border of the checkbox */
  border: _propTypes2.default.bool,
  /** if passed this will be used to generate checkbox {id value name checked disabled onClick} */
  content: _propTypes2.default.array,
  /** on change */
  onChange: _propTypes2.default.func,
  /** purple or orange **/
  colorStyle: _propTypes2.default.string,
  /** border radius */
  borderRadius: _propTypes2.default.string
};
MozartCheckBox.defaultProps = {
  style: {},
  colorStyle: 'orange',
  testId: 'MozartCheckBox',
  themeId: 'MozartCheckBox'
};
exports.default = MozartCheckBox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartInputBox/MozartCheckBox/MozartCheckBox.js
// module id = 727
// module chunks = 1